import { lazy, useEffect } from "react";
import { defineWebModule, useShell } from "@tc/ui";
import { manifest } from "./manifest.js";

const TanksPage = lazy(() => import("./web/TanksPage.js").then((m) => ({ default: m.TanksPage })));
const TankHistoryPage = lazy(() => import("./web/TanksPage.js").then((m) => ({ default: m.TankHistoryPage })));
const OffSalePage = lazy(() => import("./web/TanksPage.js").then((m) => ({ default: m.OffSalePage })));
const DeliveriesPage = lazy(() => import("./web/DeliveriesPage.js").then((m) => ({ default: m.DeliveriesPage })));
const OfficePage = lazy(() => import("./web/OfficePage.js").then((m) => ({ default: m.OfficePage })));
const OrderingPage = lazy(() => import("./web/OrderingPage.js").then((m) => ({ default: m.OrderingPage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));

/** Old /wetstock/invoices links (tasks, bookmarks): fuel invoices are the Cash Office's now (Fuel review C). */
function InvoicesMoved() {
  const { navigate } = useShell();
  useEffect(() => { navigate(`/cash-office/fuel-invoices${window.location.search}`); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default defineWebModule({ manifest, pages: { "": TanksPage, "/history": TankHistoryPage, "/off-sale": OffSalePage, "/deliveries": DeliveriesPage, "/office": OfficePage, "/invoices": InvoicesMoved, "/ordering": OrderingPage, "/settings": SettingsPage } });
